import { createFileRoute } from "@tanstack/react-router";

import { PageHero, PolicyBody } from "@/components/site/Page";
import { TermsPolicyContent } from "@/components/site/EnrollmentPolicyContent";
import { seoLinks, ogImage } from "@/lib/seo";

const TITLE = "Condiciones de uso | Swedish International School";
const DESCRIPTION =
  "Condiciones de uso del sitio web de Swedish International School: contenido, enlaces, formularios y responsabilidad.";

export const Route = createFileRoute("/es/condiciones-de-uso")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "es_ES" },
      ...ogImage(),
    ],
    links: seoLinks("/es/condiciones-de-uso"),
  }),
  component: CondicionesDeUso,
});

function CondicionesDeUso() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Condiciones de uso"
        intro="Al utilizar este sitio web aceptas las condiciones descritas a continuación."
      />

      <PolicyBody>
        <TermsPolicyContent locale="es" />
      </PolicyBody>
      <div className="h-20" />
    </>
  );
}
